const _excluded = ["passwordConfirm"];function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;} /* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useState } from 'react';

import { useLoaderData, useRevalidator } from 'react-router';
import { useForm } from 'react-hook-form';
import { useSetAtom } from 'jotai';

import { FetchResponseError } from "../../../../../shared/JSONRequest";
import { validEmailFormat } from "../../../shared/formatHelpers";
import { Translate } from "../../../../I18N";
import { updateUser, getCurrentUser } from "../../../api/users";
import { notificationAtom } from "../../../atoms";
import { InputField } from "../../../Components/Forms";
import { Button, Card, ConfirmationModal } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { TwoFactorSetup } from "./Components/TwoFactorSetup";

const accountLoader =
(headers) =>
async () =>
getCurrentUser(headers);

const Account = () => {
  const userAccount = useLoaderData();
  const [isSidepanelOpen, setIsSidepanelOpen] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const passwordConfirmation = useRef();
  const formSubmit = useRef(null);
  const setNotifications = useSetAtom(notificationAtom);
  const revalidator = useRevalidator();



  const {
    register,
    watch,
    handleSubmit,
    trigger,
    resetField,
    formState: { errors, isDirty }
  } = useForm({
    defaultValues: userAccount,
    mode: 'onSubmit'
  });

  const onSubmit = async (data, currentPassword) => {
    const { passwordConfirm } = data,userData = _objectWithoutProperties(data, _excluded);
    userData.password = userData.password ? userData.password : userAccount.password;

    const response = await updateUser(userData, currentPassword);

    if (response instanceof FetchResponseError) {var _response$json;
      const message = (_response$json = response.json) !== null && _response$json !== void 0 && _response$json.prettyMessage ? response.json.prettyMessage : response.message;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: message || undefined
      });
    } else {
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Account updated")
      });
      await revalidator.revalidate();
    }

    resetField('password');
    resetField('passwordConfirm');
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "w-full h-full overflow-y-auto", "data-testid": "settings-account" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Account" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("form", {
      id: "account-form",
      onSubmit: handleSubmit(async (data) =>
      onSubmit(data, passwordConfirmation.current || '')
      ) }, void 0, /*#__PURE__*/

    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "General Information") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      id: "account-username",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Username"),
      value: userAccount.username,
      disabled: true }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      id: "account-role",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "User Role"),
      value: userAccount.role,
      disabled: true }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "col-span-2" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "account-email",
      hasErrors: !!errors.email,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Email") },
    register('email', {
      required: true,
      validate: {
        format: (email) => validEmailFormat(email)
      }
    }))
    ),
    errors.email && /*#__PURE__*/
    _jsx("p", { className: "mt-2 text-sm text-error-600" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "A valid email is required")
    )

    )
    )
    ), /*#__PURE__*/
    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Change Password") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "new-password",
      hasErrors: !!errors.passwordConfirm,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "New password") },
    register('password'), {
      type: "password" })
    ),
    errors.passwordConfirm && /*#__PURE__*/
    _jsx("p", { className: "mt-2 text-sm text-error-600" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Passwords do not match")
    )

    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "confirm-new-password",
      hasErrors: !!errors.passwordConfirm,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Confirm new password") },
    register('passwordConfirm', { validate: (val) => val === watch('password') }), {
      type: "password" })
    )
    )
    )
    ),
    userAccount.using2fa ? /*#__PURE__*/
    _jsx(Card, {
      className: "mb-4",
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Two-Factor Authentication"),
      color: "default" }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex gap-6 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, { color: "success", disabled: true, className: "flex-none" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Activated")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Your account's security is enhanced with two-factor authentication."

    )
    )
    )
    ) : /*#__PURE__*/

    _jsx(Card, {
      className: "mb-4",
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Two-Factor Authentication"),
      color: "yellow" }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex gap-6 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "outline",
      className: "flex-none",
      onClick: () => setIsSidepanelOpen(true) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Enable")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "You should activate this feature for enhanced account security."

    )
    )
    )
    ), /*#__PURE__*/


    React.createElement("button", { type: "submit", hidden: true, "aria-hidden": "true", disabled: true, ref: formSubmit })
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx("a", {
      href: "/logout",
      "data-testid": "account-logout",
      className: "px-3 py-2 text-xs font-medium bg-white rounded-lg border hover:text-white text-error-600 border-error-600 hover:bg-error-800 hover:border-error-800 focus:outline-none focus:ring-4 focus:ring-indigo-200" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Logout")
    ), /*#__PURE__*/

    _jsx(Button, {
      type: "button",
      onClick: async () => {
        const validation = await trigger();
        if (validation) {
          setConfirmationModal(true);
        }
      },
      disabled: !isDirty }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Update")
    )
    )
    )
    ),

    userAccount.using2fa ? null : /*#__PURE__*/
    _jsx(TwoFactorSetup, { isOpen: isSidepanelOpen, closePanel: () => setIsSidepanelOpen(false) }),


    confirmationModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: "Confirm",
      body: "Confirm action",
      usePassword: true,
      onCancelClick: () => setConfirmationModal(false),
      onAcceptClick: (value) => {
        if (formSubmit.current) {
          passwordConfirmation.current = value;
          formSubmit.current.disabled = false;
          formSubmit.current.click();
          formSubmit.current.disabled = true;
          setConfirmationModal(false);
        }
      } }
    )

    ));

};

export { Account, accountLoader };